export default __webpack_public_path__ + "static/media/circle.d6da6919.svg";